import { Controller } from "stimulus";

export default class extends Controller {
  static values = { itemId: Number, itemType: String, payload: Object };

  async add(event) {
    // Prevent the parent card <a> from navigating when interacting with the queue button.
    event.preventDefault();
    event.stopPropagation();

    await window.queueDb.addToQueue({ itemId: this.itemIdValue, itemType: this.itemTypeValue, ...this.payloadValue });
    window.dispatchEvent(new CustomEvent("supercast-queue-changed"));

    window.showToast("Added to queue");
  }
}
